import axios from 'axios';
import store from '../../../../store';
import { setAllUsers } from '../../../Reducers/allUsersReducer';
import { setAllCources } from '../../../Reducers/allCourcesReducer';
import { setAllAssessments } from '../../../Reducers/allAssessmentsReducer';
import { setAllSessons } from '../../../Reducers/allSessonsReducer';
import { setAllNotes } from '../../../Reducers/allNotesReducer';
import { setUsersCources } from '../../../Reducers/usersCourcesReducer';

const { BASE_URL } = require('../azure/azure');

const getUserById = async (userId) => {
    try {
        const url = `${BASE_URL}/getUserById?id=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getUserById', error);
        return false;
    }
}

const signInUser = async (credentials) => {
    try {
        const url = `${BASE_URL}/signinUser`;
        const response = await axios.post(url, credentials);
        return response;
    } catch (error) {
        console.error('signInUser', error);
        return error.response;
    }
}

const checkForPasswordReset = async (email, Token) => {
    try {
        const url = `${BASE_URL}/checkForPasswordReset?email=${email}&token=${Token}`;
        const response = await axios.get(url);
        return response;
    } catch (error) {
        console.error('checkForPasswordReset', error);
        return error.response;
    }
}

const resetPassword = async (resetData) => {
    try {
        const url = `${BASE_URL}/resetPassword`;
        const response = await axios.post(url, resetData);
        return response;
    } catch (error) {
        console.error('resetPassword', error);
        return error.response;
    }
}

const requestPasswordReset = async (email) => {
    try {
        const url = `${BASE_URL}/requestPasswordReset?email=${email}`;
        const response = await axios.get(url);
        return response;
    } catch (error) {
        console.error('requestPasswordReset', error);
        return error.response;
    }
}

const addUser = async (user) => {
    try {
        const url = `${BASE_URL}/addUser`;
        const response = await axios.post(url, user);
        return response;
    } catch (error) {
        console.error('addUser', error);
        // Return error response if available, otherwise return a structured error object
        if (error.response) {
            return error.response;
        }
        return {
            status: 500,
            data: { success: false, message: error.message || 'Network error occurred' }
        };
    }
}

const checkIsEmailExist = async (email) => {
    try {
        const url = `${BASE_URL}/checkIsEmailExists?email=${email}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('checkIsEmailExist', error);
        return false;
    }
}

const getAllUsers = async (centerId = null) => {
    try {
        let url = `${BASE_URL}/getAllUsers`;
        if (centerId) {
            url += `?centerId=${centerId}`;
        }
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllUsers', error);
        return false;
    }
}

const createUser = async (user) => {
    try {
        const url = `${BASE_URL}/createUser`;
        const response = await axios.post(url, user);
        if (response?.status === 200) {
            await refreshUsersStore();
        }
        return response;
    } catch (error) {
        console.error('createUser', error);
        return false;
    }
}

const deleteUser = async (userId) => {
    try {
        const url = `${BASE_URL}/deleteUser?userId=${userId}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshUsersStore();
        }
        return response;
    } catch (error) {
        console.error('deleteUser', error);
        return false;
    }
}

const editUser = async (user) => {
    try {
        const url = `${BASE_URL}/editUser`;
        const response = await axios.put(url, user);
        if (response?.status === 200) {
            await refreshUsersStore();
        }
        return response;
    } catch (error) {
        console.error('editUser', error);
        return false;
    }
}

const getProgressByUserId = async (userId) => {
    try {
        const url = `${BASE_URL}/getProgressByUserId?userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getProgressByUserId', error);
        return false;
    }
}

const addCourse = async (course) => {
    try {
        const url = `${BASE_URL}/addCourse`;
        const response = await axios.post(url, course);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('addCourse', error);
        return false;
    }
}

const getAllCoursesByRole = async (role, userId = null) => {
    try {
        let url = `${BASE_URL}/getAllCoursesByRole?role=${role}`;
        
        // Add userId to the URL if provided (for non-superadmin roles)
        if (userId) {
            url += `&userId=${userId}`;
        }
        
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllCoursesByRole', error);
        return false;
    }
}

const getCourseContentByRoleAndCourseId = async (courseId, role, userId) => {
    try {
        const url = `${BASE_URL}/getCourseContentByRoleAndCourseId?role=${role}&courseId=${courseId}&userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCourseContentByRoleAndCourseId', error);
        return false;
    }
}

const enrollToCourseContent = async (courseId, userId, contentId) => {
    try {
        const url = `${BASE_URL}/enrollToCourseContent?courseId=${courseId}&userId=${userId}&courseContentId=${contentId}`;
        const response = await axios.post(url);
        return response;
    } catch (error) {
        console.error('enrollToCourseContent', error);
        return false;
    }
}

const addCourseContent = async (content) => {
    try {
        const url = `${BASE_URL}/addCourseContent`;
        const response = await axios.post(url, content);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('addCourseContent', error);
        return false;
    }
}

const editCourseContent = async (content) => {
    try {
        const url = `${BASE_URL}/editCourseContent`;
        const response = await axios.put(url, content);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('editCourseContent', error);
        return false;
    }
}

const deleteCourseContent = async (contentId) => {
    try {
        const url = `${BASE_URL}/deleteCourseContent?contentId=${contentId}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('deleteCourseContent', error);
        return false;
    }
}

const editCourse = async (course) => {
    try {
        const url = `${BASE_URL}/editCourse`;
        const response = await axios.put(url, course);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('editCourse', error);
        return false;
    }
}

const deleteCourse = async (courseId) => {
    try {
        const url = `${BASE_URL}/deleteCourse?courseId=${courseId}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('deleteCourse', error);
        return false;
    }
}

const getCourseById = async (courseId) => {
    try {
        const url = `${BASE_URL}/getCourseById?courseId=${courseId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCourseById', error);
        return false;
    }
}

const getAllUsersOfACourse = async (courseId) => {
    try {
        const url = `${BASE_URL}/getAllUsersOfACourse?courseId=${courseId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCourseById', error);
        return false;
    }
}

const buyACourse = async (data) => {
    try {
        const url = `${BASE_URL}/buyACourse`;
        const response = await axios.post(url, data);
        if (response?.status === 200) {
            await refreshUsersCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('addCourseContent', error);
        return false;
    }
}

const removeAUserFromACourse = async (userId, courseId) => {
    try {
        const url = `${BASE_URL}/removeAUserFromACourse?userId=${userId}&courseId=${courseId}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshUsersCoursesStore();
        }
        return response;
    } catch (error) {
        console.error('removeAUserFromACourse', error);
        return false;
    }
}

const getUsersCourses = async (userId) => {
    try {
        const url = `${BASE_URL}/getUsersCourses?userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getUsersCourses', error);
        return false;
    }
}

const getPaymentsByUserId = async (userId) => {
    try {
        const url = `${BASE_URL}/getPaymentsByUserId?userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getPaymentsByUserId', error);
        return false;
    }
}

const getAllPayments = async (userId = null, role = null) => {
    try {
        let url = `${BASE_URL}/getAllPayments`;
        if (userId && role) {
            url += `?userId=${userId}&role=${role}`;
        }
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllPayments', error);
        return false;
    }
}

const addAssestment = async (values) => {
    try {
        const url = `${BASE_URL}/addAssestment`;
        const response = await axios.post(url, values);
        if (response?.status === 200) {
            await refreshAssessmentsStore();
        }
        return response;
    } catch (error) {
        console.error('addAssestment', error);
        return false;
    }
}

const getAssestmentsByRole = async (role, id) => {
    try {
        const url = `${BASE_URL}/getAssestmentsByRole?role=${role}&id=${id}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAssestmentsByRole', error);
        return false;
    }
}

const getCouseAssestmentsByRole = async (courseId, role, userId) => {
    try {
        const url = `${BASE_URL}/getCouseAssestmentsByRole?courseId=${courseId}&role=${role}&userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCouseAssestmentsByRole', error);
        return false;
    }
}

const issueCertificate = async (values) => {
    try {
        const url = `${BASE_URL}/issueCertificate`;
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('issueCertificate', error);
        return error.response || false;
    }
}

const getCertificateByStudent = async (studentId, courseId) => {
    try {
        const url = `${BASE_URL}/getCertificateByStudent?studentId=${studentId}&courseId=${courseId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCertificateByStudent', error);
        return false;
    }
}

const getAllCertificates = async () => {
    try {
        const url = `${BASE_URL}/getAllCertificates`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllCertificates', error);
        return [];
    }
}

const getStudentCertificates = async (studentId) => {
    try {
        const url = `${BASE_URL}/getStudentCertificates?studentId=${studentId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getStudentCertificates', error);
        return [];
    }
}

const deleteCertificate = async (certificateId) => {
    try {
        const url = `${BASE_URL}/deleteCertificate?CertificateID=${encodeURIComponent(certificateId)}`;
        const response = await axios.delete(url);
        return response;
    } catch (error) {
        console.error('deleteCertificate', error);
        return error.response;
    }
}

const verifyCertificate = async (certificateNumber) => {
    try {
        const url = `${BASE_URL}/verifyCertificate?certificateNumber=${encodeURIComponent(certificateNumber)}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('verifyCertificate', error);
        return { success: false, verified: false, message: 'Verification service error' };
    }
}

const createCertificateTemplate = async (values) => {
    try {
        const url = `${BASE_URL}/createCertificateTemplate`;
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('createCertificateTemplate', error);
        return error.response || false;
    }
}

const updateCertificateTemplate = async (values) => {
    try {
        const url = `${BASE_URL}/updateCertificateTemplate`;
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('updateCertificateTemplate', error);
        return error.response || false;
    }
}

const getAllCertificateTemplates = async () => {
    try {
        const url = `${BASE_URL}/getAllCertificateTemplates`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllCertificateTemplates', error);
        return [];
    }
}

const createBadge = async (values) => {
    try {
        const url = `${BASE_URL}/createBadge`;
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('createBadge', error);
        return error.response;
    }
}

const issueBadge = async (values) => {
    try {
        const url = `${BASE_URL}/issueBadge`;
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('issueBadge', error);
        return error.response;
    }
}

const getBadgesByStudent = async (studentId) => {
    try {
        const url = `${BASE_URL}/getBadgesByStudent?studentId=${studentId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getBadgesByStudent', error);
        return [];
    }
}

const getAllBadges = async () => {
    try {
        const url = `${BASE_URL}/getAllBadges`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllBadges', error);
        return [];
    }
}

const getAllStudentBadges = async () => {
    try {
        const url = `${BASE_URL}/getAllStudentBadges`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllStudentBadges', error);
        return [];
    }
}

const editAssestment = async (values) => {
    try {
        const url = `${BASE_URL}/editAssestment`;
        const response = await axios.put(url, values);
        if (response?.status === 200) {
            await refreshAssessmentsStore();
        }
        return response;
    } catch (error) {
        console.error('editAssestment', error);
        return false;
    }
}

const reviewAssestmentSubmission = async (values) => {
    try {
        const url = `${BASE_URL}/reviewAssestmentSubmission`;
        const response = await axios.put(url, values);
        return response;
    } catch (error) {
        console.error('reviewAssestmentSubmission', error);
        return false;
    }
}

const getSubmissionsByAssestment = async (id) => {
    try {
        const url = `${BASE_URL}/getSubmissionsByAssestment?id=${id}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getSubmissionsByAssestment', error);
        return false;
    }
}

const deleteAssessmentSubmission = async (id) => {
    try {
        const url = `${BASE_URL}/deleteAssessmentSubmission?id=${id}`;
        const response = await axios.delete(url);
        return response;
    } catch (error) {
        console.error('deleteAssessmentSubmission', error);
        return false;
    }
}

const attemptToAssestment = async (values) => {
    try {
        const url = `${BASE_URL}/attemptToAssestment`;
        console.log('Sending assessment attempt with data:', values);
        const response = await axios.post(url, values);
        return response;
    } catch (error) {
        console.error('attemptToAssestment error:', error);
        console.error('Request data:', values);
        return error.response || false;
    }
}

const editAttempt = async (values) => {
    try {
        const url = `${BASE_URL}/editAttempt`;
        const response = await axios.put(url, values);
        return response;
    } catch (error) {
        console.error('editAttempt', error);
        return false;
    }
}

const getAssementByIdAndRole = async (id, role, urerId) => {
    try {
        const url = `${BASE_URL}/getAssementByIdAndRole?id=${id}&role=${role}&userId=${urerId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAssementByIdAndRole', error);
        return false;
    }
}

const deleteAssestment = async (id) => {
    try {
        const url = `${BASE_URL}/deleteAssestment?id=${id}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshAssessmentsStore();
        }
        return response;
    } catch (error) {
        console.error('deleteAssestment', error);
        return false;
    }
}

const addSession = async (session) => {
    try {
        const url = `${BASE_URL}/addSession`;
        const response = await axios.post(url, session);
        if (response?.status === 200) {
            await refreshSessionsStore();
        }
        return response;
    } catch (error) {
        console.error('addSession', error);
        return false;
    }
}

const getSessions = async (role, userId) => {
    try {
        const url = `${BASE_URL}/getSessions?role=${role}&userId=${userId}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.error('getSessions', error);
        return false;
    }
}

const deleteSession = async (id) => {
    try {
        const url = `${BASE_URL}/deleteSession?id=${id}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshSessionsStore();
        }
        return response;
    } catch (error) {
        console.error('deleteSession', error);
        return false;
    }
}

const editSession = async (session) => {
    try {
        const url = `${BASE_URL}/editSession`;
        const response = await axios.put(url, session);
        if (response?.status === 200) {
            await refreshSessionsStore();
        }
        return response;
    } catch (error) {
        console.error('editSession', error);
        return false;
    }
}

const addNote = async (note) => {
    try {
        const url = `${BASE_URL}/addNote`;
        const response = await axios.post(url, note);
        if (response?.status === 200) {
            await refreshNotesStore();
        }
        return response;
    } catch (error) {
        console.error('addNote', error);
        return false;
    }
}


const deleteNote = async (id) => {
    try {
        const url = `${BASE_URL}/deleteNote?noteId=${id}`;
        const response = await axios.delete(url);
        if (response?.status === 200) {
            await refreshNotesStore();
        }
        return response;
    } catch (error) {
        console.error('deleteNote', error);
        return false;
    }
}

const attendToSession = async (sessionId, userId, isRepeat) => {
    isRepeat = isRepeat ? true : false;
    try {
        const url = `${BASE_URL}/attendToSession?sessionId=${sessionId}&userId=${userId}&isRepeat=${isRepeat}`;
        const response = await axios.post(url);
        return response;
    } catch (error) {
        console.error('attendToSession', error);
        return false;
    }
}

const getSessionById = async (sessionId) => {
    try {
        const url = `${BASE_URL}/getSessionById?sessionId=${sessionId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getSessionById', error);
        return false;
    }
}

const getAttendanceBySession = async (sessionId, isRepeat, sessionDate) => {
    try {
        const url = `${BASE_URL}/getAttendanceBySession?sessionId=${sessionId}&isRepeat=${isRepeat}&sessionDate=${sessionDate}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAttendanceBySession', error);
        return false;
    }
}

const getHomeCourses = async () => {
    try {
        const url = `${BASE_URL}/getHomeCourses`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getHomeCourses', error);
        return false;
    }
}

const getDashboardHomeCources = async () => {
    try {
        const url = `${BASE_URL}/getDashboardHomeCources`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getDashboardHomeCources', error);
        return false;
    }
}

const getNotesByUser = async (userId, role) => {
    try {
        const url = `${BASE_URL}/getNotesByUser?userId=${userId}&role=${role}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getNotesByUser', error);
        return false;
    }
}


const getCoordinatorStats = async (coordinatorId) => {
    try {
        const url = `${BASE_URL}/getCoordinatorStats?coordinatorId=${coordinatorId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCoordinatorStats', error);
        return false;
    }
}

const getCoordinatorChartData = async (coordinatorId) => {
    try {
        const url = `${BASE_URL}/getCoordinatorChartData?coordinatorId=${coordinatorId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCoordinatorChartData', error);
        return false;
    }
}

const deletePayment = async (paymentId) => {
    try {
        const url = `${BASE_URL}/deletePayment?paymentId=${paymentId}`;
        const response = await axios.delete(url);
        return response;
    } catch (error) {
        console.error('deletePayment', error);
        return false;
    }
}

// Paycorp API Functions
const createPaycorpPaymentLink = async (paymentData) => {
    try {
        const url = `${BASE_URL}/payments/paycorp/create-link`;
        const response = await axios.post(url, paymentData);
        return response.data;
    } catch (error) {
        console.error('createPaycorpPaymentLink', error);
        return { success: false, message: error.response?.data?.message || 'Failed to create payment link' };
    }
}

const verifyPaycorpPayment = async (reqid, clientRef) => {
    try {
        const url = `${BASE_URL}/payments/paycorp/verify`;
        const response = await axios.post(url, { reqid, clientRef });
        return response.data;
    } catch (error) {
        console.error('verifyPaycorpPayment', error);
        return { success: false, message: error.response?.data?.message || 'Failed to verify payment' };
    }
}

const getPaymentStatus = async (paymentId) => {
    try {
        const url = `${BASE_URL}/payments/status/${paymentId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getPaymentStatus', error);
        return { success: false, message: error.response?.data?.message || 'Failed to check payment status' };
    }
}


const getWishListCourcesByUser = async (userId) => {
    try {
        const url = `${BASE_URL}/getWishListCourcesByUser?userId=${userId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getWishListCourcesByUser', error);
        return false;
    }
}

const getFavouritesByCourse = async (courseId) => {
    try {
        const url = `${BASE_URL}/getFavouritesByCourse?courseId=${courseId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getWishListCourcesByUser', error);
        return false;
    }
}


const removeCourseFromWishList = async (userId, courseId) => {
    try {
        const url = `${BASE_URL}/removeCourseFromWishList?userId=${userId}&courseId=${courseId}`;
        const response = await axios.put(url);
        return response;
    } catch (error) {
        console.error('removeCourseFromWishList', error);
        return false;
    }
}


const addCourseToWishList = async (userId, courseId) => {
    try {
        const url = `${BASE_URL}/addCourseToWishList?userId=${userId}&courseId=${courseId}`;
        const response = await axios.put(url);
        return response;
    } catch (error) {
        console.error('addCourseToWishList', error);
        return false;
    }
}

const getAllWishLists = async () => {
    try {
        const url = `${BASE_URL}/getAllWishLists`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllWishLists', error);
        return false;
    }
}

const getCourcesAndCorseWishListUsers = async () => {
    try {
        const url = `${BASE_URL}/getCourcesAndCorseWishListUsers`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllWishLists', error);
        return false;
    }
}

const addCenter = async (centerData) => {
    try {
        const url = `${BASE_URL}/addCenter`;
        const response = await axios.post(url, centerData);
        return response;
    } catch (error) {
        console.error('addCenter', error);
        return false;
    }
}

const editCenter = async (centerData) => {
    try {
        const url = `${BASE_URL}/editCenter`;
        const response = await axios.put(url, centerData);
        return response;
    } catch (error) {
        console.error('editCenter', error);
        return false;
    }
}

const deleteCenter = async (centerId) => {
    try {
        const url = `${BASE_URL}/deleteCenter?centerId=${centerId}`;
        const response = await axios.delete(url);
        return response;
    } catch (error) {
        console.error('deleteCenter', error);
        throw error; // Re-throw the error so it can be caught properly
    }
}

const getAllCenters = async () => {
    try {
        const url = `${BASE_URL}/getAllCenters`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllCenters', error);
        return false;
    }
}

const getCenterById = async (centerId) => {
    try {
        const url = `${BASE_URL}/getCenterById?centerId=${centerId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getCenterById', error);
        return false;
    }
}

// Inquiries API Calls
const submitInquiry = async (inquiryData) => {
    try {
        const url = `${BASE_URL}/inquiries`;
        const response = await axios.post(url, inquiryData);
        return response.data;
    } catch (error) {
        console.error('submitInquiry', error);
        return { success: false, message: error.response?.data?.message || 'Failed to submit inquiry' };
    }
}

const getAllInquiries = async () => {
    try {
        const url = `${BASE_URL}/inquiries`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllInquiries', error);
        return [];
    }
}

const updateInquiryStatus = async (id, status) => {
    try {
        const url = `${BASE_URL}/inquiries/${id}`;
        const response = await axios.put(url, { status });
        return response.data;
    } catch (error) {
        console.error('updateInquiryStatus', error);
        return { success: false, message: error.response?.data?.message || 'Failed to update inquiry status' };
    }
}

const deleteInquiry = async (id) => {
    try {
        const url = `${BASE_URL}/inquiries/${id}`;
        const response = await axios.delete(url);
        return response.data;
    } catch (error) {
        console.error('deleteInquiry', error);
        return { success: false, message: error.response?.data?.message || 'Failed to delete inquiry' };
    }
}

// Website Content: Testimonials
const getAllTestimonials = async () => {
    try {
        const url = `${BASE_URL}/testimonials`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllTestimonials', error);
        return [];
    }
}

const createTestimonial = async (data) => {
    try {
        const url = `${BASE_URL}/testimonials`;
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        console.error('createTestimonial', error);
        return { success: false, message: error.response?.data?.message || 'Failed to create testimonial' };
    }
}

const updateTestimonial = async (id, data) => {
    try {
        const url = `${BASE_URL}/testimonials/${id}`;
        const response = await axios.put(url, data);
        return response.data;
    } catch (error) {
        console.error('updateTestimonial', error);
        return { success: false, message: error.response?.data?.message || 'Failed to update testimonial' };
    }
}

const deleteTestimonial = async (id) => {
    try {
        const url = `${BASE_URL}/testimonials/${id}`;
        const response = await axios.delete(url);
        return response.data;
    } catch (error) {
        console.error('deleteTestimonial', error);
        return { success: false, message: error.response?.data?.message || 'Failed to delete testimonial' };
    }
}

// Website Content: Academic Panel
const getAllAcademicPanelMembers = async () => {
    try {
        const url = `${BASE_URL}/academic-panel`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('getAllAcademicPanelMembers', error);
        return [];
    }
}

const createAcademicPanelMember = async (data) => {
    try {
        const url = `${BASE_URL}/academic-panel`;
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        console.error('createAcademicPanelMember', error);
        return { success: false, message: error.response?.data?.message || 'Failed to create panel member' };
    }
}

const updateAcademicPanelMember = async (id, data) => {
    try {
        const url = `${BASE_URL}/academic-panel/${id}`;
        const response = await axios.put(url, data);
        return response.data;
    } catch (error) {
        console.error('updateAcademicPanelMember', error);
        return { success: false, message: error.response?.data?.message || 'Failed to update panel member' };
    }
}

const deleteAcademicPanelMember = async (id) => {
    try {
        const url = `${BASE_URL}/academic-panel/${id}`;
        const response = await axios.delete(url);
        return response.data;
    } catch (error) {
        console.error('deleteAcademicPanelMember', error);
        return { success: false, message: error.response?.data?.message || 'Failed to delete panel member' };
    }
}

function getCachedUser() {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const raw = localStorage.getItem('digital-academy-user');
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.error('getCachedUser', error);
        return null;
    }
}

async function refreshUsersStore() {
    const cachedUser = getCachedUser();
    let centerFilter = null;
    if (cachedUser?.role === 'admin' && cachedUser?.centerId) {
        centerFilter = cachedUser.centerId;
    }
    const users = await getAllUsers(centerFilter);
    if (users) {
        store.dispatch(setAllUsers(users));
    }
}

async function refreshCoursesStore() {
    const cachedUser = getCachedUser();
    if (!cachedUser?.role) {
        return;
    }
    const courses = await getAllCoursesByRole(cachedUser.role, cachedUser.id);
    if (courses) {
        store.dispatch(setAllCources(courses));
    }
}

async function refreshAssessmentsStore() {
    const cachedUser = getCachedUser();
    if (!cachedUser?.role || !cachedUser?.id) {
        return;
    }
    const assessments = await getAssestmentsByRole(cachedUser.role, cachedUser.id);
    if (assessments) {
        store.dispatch(setAllAssessments(assessments));
    }
}

async function refreshSessionsStore() {
    const cachedUser = getCachedUser();
    if (!cachedUser?.role || !cachedUser?.id) {
        return;
    }
    const sessions = await getSessions(cachedUser.role, cachedUser.id);
    if (sessions) {
        store.dispatch(setAllSessons(sessions));
    }
}

async function refreshNotesStore() {
    const cachedUser = getCachedUser();
    if (!cachedUser?.role || !cachedUser?.id) {
        return;
    }
    const notes = await getNotesByUser(cachedUser.id, cachedUser.role);
    if (notes) {
        store.dispatch(setAllNotes(notes));
    }
}

async function refreshUsersCoursesStore() {
    const cachedUser = getCachedUser();
    if (!cachedUser?.id) {
        return;
    }
    const courses = await getUsersCourses(cachedUser.id);
    if (courses) {
        store.dispatch(setUsersCources(courses));
    }
}

const submitPaymentSlip = async (paymentData) => {
    try {
        const url = `${BASE_URL}/payments/submit-slip`;
        const response = await axios.post(url, paymentData);
        return response.data;
    } catch (error) {
        console.error('submitPaymentSlip', error);
        return { success: false, message: error.response?.data?.message || 'Failed to submit payment slip' };
    }
}

const verifyPaymentSlip = async (paymentId, status) => {
    try {
        const url = `${BASE_URL}/payments/verify-slip`;
        const response = await axios.post(url, { paymentId, status });
        return response.data;
    } catch (error) {
        console.error('verifyPaymentSlip', error);
        return { success: false, message: error.response?.data?.message || 'Failed to verify payment slip' };
    }
}

export {
    getUserById,
    signInUser,
    checkForPasswordReset,
    resetPassword,
    requestPasswordReset,
    addUser,
    checkIsEmailExist,
    getAllUsers,
    createUser,
    deleteUser,
    editUser,
    getProgressByUserId,
    addCourse,
    getAllCoursesByRole,
    getCourseContentByRoleAndCourseId,
    enrollToCourseContent,
    addCourseContent,
    editCourseContent,
    deleteCourseContent,
    editCourse,
    deleteCourse,
    getCourseById,
    getAllUsersOfACourse,
    buyACourse,
    removeAUserFromACourse,
    getUsersCourses,
    getPaymentsByUserId,
    getAllPayments,
    addAssestment,
    getAssestmentsByRole,
    editAssestment,
    reviewAssestmentSubmission,
    getSubmissionsByAssestment,
    deleteAssessmentSubmission,
    attemptToAssestment,
    editAttempt,
    getAssementByIdAndRole,
    deleteAssestment,
    addSession,
    getSessions,
    deleteSession,
    editSession,
    addNote,
    deleteNote,
    attendToSession,
    getSessionById,
    getAttendanceBySession,
    getHomeCourses,
    getDashboardHomeCources,
    getNotesByUser,
    deletePayment,
    createPaycorpPaymentLink,
    verifyPaycorpPayment,
    getPaymentStatus,
    getWishListCourcesByUser,
    removeCourseFromWishList,
    addCourseToWishList,
    getFavouritesByCourse,
    getAllWishLists,
    getCourcesAndCorseWishListUsers,
    getCouseAssestmentsByRole,
    issueCertificate,
    getCertificateByStudent,
    getAllCertificates,
    getStudentCertificates,
    deleteCertificate,
    createCertificateTemplate,
    updateCertificateTemplate,
    getAllCertificateTemplates,
    createBadge,
    issueBadge,
    getBadgesByStudent,
    getAllBadges,
    getAllStudentBadges,
    addCenter,
    editCenter,
    deleteCenter,
    getAllCenters,
    getCenterById,
    submitInquiry,
    getAllInquiries,
    updateInquiryStatus,
    deleteInquiry,
    getAllTestimonials,
    createTestimonial,
    updateTestimonial,
    deleteTestimonial,
    getAllAcademicPanelMembers,
    createAcademicPanelMember,
    updateAcademicPanelMember,
    deleteAcademicPanelMember,
    getCoordinatorStats,
    getCoordinatorChartData,
    submitPaymentSlip,
    verifyPaymentSlip,
    verifyCertificate,
}